import React, { useState } from "react";
import DataTable, { TableColumn } from "../DataTableNew";

const NewMemberEnrollmentTable = ({
  columns,
  data,
  page,
  setPage,
  handlePageChange,
  totalPage,
  loading,
  title,
  total_pages,
  showCheckbox = false,       // new prop
  selectedRows = [],          // array of selected row IDs
  onCheck,                    // handler for checkbox toggle
}) => {
  // handle pagination
  const handleNextPage = () => {
    handlePageChange(page + 1);
  };

  const handlePriviousPage = () => {
    handlePageChange(page - 1);
  };



  return (
    <div className="mt-8">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {title} Report
        </h2>
      </div>

      <DataTable
        columns={columns}
        data={data}
        loading={loading}
        pagination={{
          currentPage: page,
          handleNextPage,
          handlePriviousPage,
          setPage,
          totalPage,
          total_pages,
        }}
        emptyMessage="No data found. Please adjust your search criteria."
        showCheckbox={showCheckbox}       // pass down
        selectedRows={selectedRows}       // pass down
        onCheck={onCheck}                 // pass down
      />
    </div>
  );
};

export default NewMemberEnrollmentTable;
